/**
 * Updates `additional` for both Errors counter and RUM \
 * Make sure data you setting both small and important as context to all rum metrics.
 * Don't add to additional something you can send via logEvent
 */
export function updateAdditional(additional: Record<string, unknown>) {
  try {
    // Error and Event counters
    Ya.Rum.updateAdditional(additional)

    // RUM
    const rumAdditionalCurrent = JSON.parse(Ya.Rum._vars['-additional'] || '{}')
    Ya.Rum.setVars({
      '-additional': JSON.stringify({...rumAdditionalCurrent, ...additional})
    })
  } catch (error) {
    console.error(error)
  }
}
